module.exports={"(optional)":"(facultatif)","(required)":"(requis)"};